export const getAppIsMobile = state => state.app.isMobile;

export const isAnnouncementsModalOpen = state =>
  state.app.showAnnouncementsModal;

export const getActiveAnnouncements = state => state.app.activeAnnouncements;

export const hasSeenAnnouncements = state => state.app.hasSeenAnnouncements;
